import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PlanBenefits',
  setup(__props) {

const benefits = [
  'Unlimited users',
  'Private workspaces',
  'Snaplore AI',
  'Priority support',
  'Unlimited recordings',
  'Sign-In with Google',
  'Slack integration',
];

return { __sfc: true,benefits }
}

})